/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CFPreferenceResponse } from '../models/CFPreferenceResponse';
import type { ReviewGPTFormDataResponse } from '../models/ReviewGPTFormDataResponse';
import type { SaveCFPreferenceRequest } from '../models/SaveCFPreferenceRequest';
import type { SaveCFPreferenceResponse } from '../models/SaveCFPreferenceResponse';
import type { SaveReviewGPTFormDataRequest } from '../models/SaveReviewGPTFormDataRequest';
import type { SaveReviewGPTFormDataResponse } from '../models/SaveReviewGPTFormDataResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReviewGptService {

    /**
     * Get Review Gpt Form Data
     * Get saved ReviewGPT form data for a specific employee.
     *
     * The form data is keyed by the current user (manager) and the employee being reviewed.
     * Will error if current user is not a manager of the given employee.
     * @param employeeId
     * @param isSandbox
     * @returns ReviewGPTFormDataResponse Successful Response
     * @throws ApiError
     */
    public static getReviewGptFormDataApiV1ReviewGptFormEmployeeIdGet(
        employeeId: string,
        isSandbox: boolean = false,
    ): CancelablePromise<ReviewGPTFormDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/review-gpt/form/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Review Gpt Form Data
     * Save ReviewGPT form data for a specific employee.
     *
     * The form data is keyed by the current user (manager) and the employee being reviewed.
     * Will error if current user is not a manager of the given employee.
     * @param employeeId
     * @param requestBody
     * @param isSandbox
     * @returns SaveReviewGPTFormDataResponse Successful Response
     * @throws ApiError
     */
    public static saveReviewGptFormDataApiV1ReviewGptFormEmployeeIdPut(
        employeeId: string,
        requestBody: SaveReviewGPTFormDataRequest,
        isSandbox: boolean = false,
    ): CancelablePromise<SaveReviewGPTFormDataResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/review-gpt/form/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Review Gpt Form Data
     * Delete ReviewGPT form data for a specific employee.
     *
     * Will error if current user is not a manager of the given employee.
     * @param employeeId
     * @param isSandbox
     * @returns SaveReviewGPTFormDataResponse Successful Response
     * @throws ApiError
     */
    public static deleteReviewGptFormDataApiV1ReviewGptFormEmployeeIdDelete(
        employeeId: string,
        isSandbox: boolean = false,
    ): CancelablePromise<SaveReviewGPTFormDataResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/review-gpt/form/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cf Preference
     * Get the CF preference for an employee.
     * @param employeeId
     * @param isSandbox
     * @returns CFPreferenceResponse Successful Response
     * @throws ApiError
     */
    public static getCfPreferenceApiV1ReviewGptCfPreferenceEmployeeIdGet(
        employeeId: string,
        isSandbox: boolean = false,
    ): CancelablePromise<CFPreferenceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/review-gpt/cf-preference/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Cf Preference
     * Save a CF preference for an employee.
     * @param employeeId
     * @param requestBody
     * @param isSandbox
     * @returns SaveCFPreferenceResponse Successful Response
     * @throws ApiError
     */
    public static saveCfPreferenceApiV1ReviewGptCfPreferenceEmployeeIdPut(
        employeeId: string,
        requestBody: SaveCFPreferenceRequest,
        isSandbox: boolean = false,
    ): CancelablePromise<SaveCFPreferenceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/review-gpt/cf-preference/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Cf Preference
     * Delete the CF preference for an employee.
     * @param employeeId
     * @param isSandbox
     * @returns SaveCFPreferenceResponse Successful Response
     * @throws ApiError
     */
    public static deleteCfPreferenceApiV1ReviewGptCfPreferenceEmployeeIdDelete(
        employeeId: string,
        isSandbox: boolean = false,
    ): CancelablePromise<SaveCFPreferenceResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/review-gpt/cf-preference/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
